<template>
  <page :back-to="getPreviousUrl" :title="pageTitle" size="is-desktop">
    <div slot="page-header-right">

      <button class="button is-outlined mr-2 is-danger" @click="confirmDestroy()">Delete</button>

      <button
        class="button is-primary"
        @click="save"
      >Save
      </button>
    </div>

    <form @submit.prevent="save">
      <button ref="submitButton" type="submit" class="is-hidden"></button>

      <div class="columns">
        <div class="column is-8">

          <div class="box">
            <b-field label="Title">
              <b-input v-model="form.title"></b-input>
            </b-field>
          </div>
        </div>
      </div>
    </form>
  </page>
</template>

<script>
export default {


  props: {
    category: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      form: new window.Form({
        title: this.category ? this.category.title : null,
        category_id: this.category ? this.category.category_id : null,
      })
    };
  },

  computed: {
    isEdit() {
      return this.category != null;
    },
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },

    pageTitle() {
      return "Magazine / Category / Edit";
    },

  },

  methods: {
    save() {
      this.isEdit ? this.update() : this.create();
    },
    update() {
      this.form
        .put(`/admin/api/magazine/categories/${this.category.id}`)
        .then(this.whenSaved);
    },
    confirmDestroy() {
      this.$buefy.dialog.confirm({
        title: "Deleting category",
        message:
          "Are you sure you want to <b>delete</b> this category? This action cannot be undone.",
        confirmText: "Delete category",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.destroy()
      });

    },
    whenSaved() {
      this.$buefy.toast.open("Category Edited");

      this.$router.push("/magazine/categories");
    },
    destroy() {
      let loading = this.$buefy.loading.open();

      new window.Form()
        .delete(`/admin/api/magazine/categories/${this.category.id}`)
        .then(() => {
          this.$buefy.toast.open("Category Deleted.");

          loading.close();

          this.$router.push("/magazine/categories");
        })
        .catch(() => loading.close());
    }
  }
};
</script>
